import type { AboutPageConfig, HomePageConfig, SiteConfig, WorkPageConfig } from "./types"

export type PreviewStory = {
  id?: string
  slug: string
  title: string
  date: number | string
  excerpt: string
  body: string
  hero?: string
  tags?: string[]
  categories?: string[]
}

export type PreviewDraft = {
  site: SiteConfig
  homepage: HomePageConfig
  stories: { posts: PreviewStory[] }
  work: WorkPageConfig
  about: AboutPageConfig
}

export const PREVIEW_STORAGE_KEY = "leah-admin-preview-draft"
export const PREVIEW_MESSAGE = "leah-admin-preview"
export const PREVIEW_READY = "leah-admin-preview-ready"

export function isPreviewMode() {
  if (typeof window === "undefined") return false
  if (new URLSearchParams(window.location.search).has("adminPreview")) return true
  return window.parent !== window && Boolean(sessionStorage.getItem(PREVIEW_STORAGE_KEY))
}

export function readPreviewDraft(): PreviewDraft | undefined {
  try {
    const raw = sessionStorage.getItem(PREVIEW_STORAGE_KEY)
    if (!raw) return undefined
    return JSON.parse(raw) as PreviewDraft
  } catch {
    return undefined
  }
}

export function writePreviewDraft(draft: PreviewDraft) {
  sessionStorage.setItem(PREVIEW_STORAGE_KEY, JSON.stringify(draft))
}

export function clearPreviewDraft() {
  sessionStorage.removeItem(PREVIEW_STORAGE_KEY)
}

export function publishPreviewDraft(draft: PreviewDraft, target?: Window | null) {
  writePreviewDraft(draft)
  target?.postMessage({ type: PREVIEW_MESSAGE, draft }, window.location.origin)
}
